// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func } from 'prop-types'
import { ProjectCreate } from 'components'

const CopyProjects = props => {
  const {
    closeModal,
    highlightedRows,
  } = props

  return (
    <div id={'copy-project-modal-body'}>
      <span
        id={'home-newProjectModalClose'}
        className={'pull-right pointer'}
        onClick={closeModal}>
        {'X'}
      </span>
      <h3
        id={'copy-project-modal-heading'}
        className={'uppercase'}>
        {'Copy Project'}
      </h3>
      <ProjectCreate
        projectIds={highlightedRows} />
    </div>
  )
}

CopyProjects.propTypes = {
  closeModal: func.isRequired,
  highlightedRows: array.isRequired,
}

export default CopyProjects
